/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"
import * as Apollo from "@apollo/client"

import * as Types from "../../../shared/types/__generated__/graphql"
import { AttachmentFragmentDoc } from "./fragments.generated"

type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }

const defaultOptions = {} as const
export type CreateAttachmentInput = {
  category?: string | null
  fileName: string
  id: string
  position?: number | null
  title?: string | null
}

export type CreateAttachmentLinkInput = {
  attachmentId: string
}

export type UpdateAttachmentInput = {
  fileName: string
  id: string
  title?: string | null
}

export type CreateAttachmentMutationVariables = Exact<{
  id: string
  type: string
  input: Types.CreateAttachmentInput
}>

export type CreateAttachmentMutation = {
  __typename: "Mutation"
  attachment: {
    __typename: "AttachmentType"
    id: string
    createdAt?: string | null
    updatedAt?: string | null
    fileName: string
    title?: string | null
    category?: string | null
    position?: number | null
    mimeType?: string | null
    extension?: string | null
    name?: string | null
    readUrl: string
    writeUrl?: { __typename: "AttachmentURL"; url: string; fields: any } | null
  }
}

export type CreateAttachmentLinkMutationVariables = Exact<{
  id: string
  type: string
  input: Types.CreateAttachmentLinkInput
}>

export type CreateAttachmentLinkMutation = {
  __typename: "Mutation"
  attachment: {
    __typename: "AttachmentType"
    id: string
    createdAt?: string | null
    updatedAt?: string | null
    fileName: string
    title?: string | null
    category?: string | null
    position?: number | null
    mimeType?: string | null
    extension?: string | null
    name?: string | null
    readUrl: string
    writeUrl?: { __typename: "AttachmentURL"; url: string; fields: any } | null
  }
}

export type DeleteAttachmentLinkMutationVariables = Exact<{
  id: string
  type: string
  attachmentId: string
}>

export type DeleteAttachmentLinkMutation = {
  __typename: "Mutation"
  deleteAttachmentLink: { __typename: "DeleteResponse"; success: boolean }
}

export type UpdateAttachmentMutationVariables = Exact<{
  id: string
  input: Types.UpdateAttachmentInput
}>

export type UpdateAttachmentMutation = {
  __typename: "Mutation"
  attachment: {
    __typename: "AttachmentType"
    id: string
    createdAt?: string | null
    updatedAt?: string | null
    fileName: string
    title?: string | null
    category?: string | null
    position?: number | null
    mimeType?: string | null
    extension?: string | null
    name?: string | null
    readUrl: string
    writeUrl?: { __typename: "AttachmentURL"; url: string; fields: any } | null
  }
}

export type DeleteAttachmentMutationVariables = Exact<{
  id: string
}>

export type DeleteAttachmentMutation = {
  __typename: "Mutation"
  attachment: { __typename: "DeleteResponse"; success: boolean }
}

export const CreateAttachmentDocument = gql`
  mutation CreateAttachment(
    $id: ID!
    $type: String!
    $input: CreateAttachmentInput!
  ) {
    attachment: createAttachment(id: $id, type: $type, input: $input)
      @rest(
        type: "AttachmentType"
        bodySerializer: "attachment"
        method: "POST"
        path: "/project-list/{args.type}/{args.id}/attachments"
      ) {
      ...Attachment
    }
  }
  ${AttachmentFragmentDoc}
`
export type CreateAttachmentMutationFn = Apollo.MutationFunction<
  CreateAttachmentMutation,
  CreateAttachmentMutationVariables
>

/**
 * __useCreateAttachmentMutation__
 *
 * To run a mutation, you first call `useCreateAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAttachmentMutation, { data, loading, error }] = useCreateAttachmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAttachmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAttachmentMutation,
    CreateAttachmentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateAttachmentMutation,
    CreateAttachmentMutationVariables
  >(CreateAttachmentDocument, options)
}
export type CreateAttachmentMutationHookResult = ReturnType<
  typeof useCreateAttachmentMutation
>
export type CreateAttachmentMutationResult =
  Apollo.MutationResult<CreateAttachmentMutation>
export type CreateAttachmentMutationOptions = Apollo.BaseMutationOptions<
  CreateAttachmentMutation,
  CreateAttachmentMutationVariables
>
export const CreateAttachmentLinkDocument = gql`
  mutation CreateAttachmentLink(
    $id: ID!
    $type: String!
    $input: CreateAttachmentLinkInput!
  ) {
    attachment: createAttachmentLink(id: $id, type: $type, input: $input)
      @rest(
        type: "AttachmentType"
        method: "POST"
        path: "/project-list/{args.type}/{args.id}/attachment-link"
      ) {
      ...Attachment
    }
  }
  ${AttachmentFragmentDoc}
`
export type CreateAttachmentLinkMutationFn = Apollo.MutationFunction<
  CreateAttachmentLinkMutation,
  CreateAttachmentLinkMutationVariables
>

/**
 * __useCreateAttachmentLinkMutation__
 *
 * To run a mutation, you first call `useCreateAttachmentLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAttachmentLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAttachmentLinkMutation, { data, loading, error }] = useCreateAttachmentLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAttachmentLinkMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAttachmentLinkMutation,
    CreateAttachmentLinkMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateAttachmentLinkMutation,
    CreateAttachmentLinkMutationVariables
  >(CreateAttachmentLinkDocument, options)
}
export type CreateAttachmentLinkMutationHookResult = ReturnType<
  typeof useCreateAttachmentLinkMutation
>
export type CreateAttachmentLinkMutationResult =
  Apollo.MutationResult<CreateAttachmentLinkMutation>
export type CreateAttachmentLinkMutationOptions = Apollo.BaseMutationOptions<
  CreateAttachmentLinkMutation,
  CreateAttachmentLinkMutationVariables
>
export const DeleteAttachmentLinkDocument = gql`
  mutation DeleteAttachmentLink(
    $id: ID!
    $type: String!
    $attachmentId: String!
  ) {
    deleteAttachmentLink(id: $id, type: $type, attachmentId: $attachmentId)
      @rest(
        type: "DeleteResponse"
        method: "DELETE"
        endpoint: "delete"
        path: "/project-list/{args.type}/{args.id}/attachment-link?attachmentId={args.attachmentId}"
      ) {
      success
    }
  }
`
export type DeleteAttachmentLinkMutationFn = Apollo.MutationFunction<
  DeleteAttachmentLinkMutation,
  DeleteAttachmentLinkMutationVariables
>

/**
 * __useDeleteAttachmentLinkMutation__
 *
 * To run a mutation, you first call `useDeleteAttachmentLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAttachmentLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAttachmentLinkMutation, { data, loading, error }] = useDeleteAttachmentLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *      attachmentId: // value for 'attachmentId'
 *   },
 * });
 */
export function useDeleteAttachmentLinkMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteAttachmentLinkMutation,
    DeleteAttachmentLinkMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteAttachmentLinkMutation,
    DeleteAttachmentLinkMutationVariables
  >(DeleteAttachmentLinkDocument, options)
}
export type DeleteAttachmentLinkMutationHookResult = ReturnType<
  typeof useDeleteAttachmentLinkMutation
>
export type DeleteAttachmentLinkMutationResult =
  Apollo.MutationResult<DeleteAttachmentLinkMutation>
export type DeleteAttachmentLinkMutationOptions = Apollo.BaseMutationOptions<
  DeleteAttachmentLinkMutation,
  DeleteAttachmentLinkMutationVariables
>
export const UpdateAttachmentDocument = gql`
  mutation UpdateAttachment($id: ID!, $input: UpdateAttachmentInput!) {
    attachment: updateAttachment(id: $id, input: $input)
      @rest(
        type: "AttachmentType"
        bodySerializer: "attachment"
        method: "PUT"
        path: "/project-list/attachments/{args.id}"
      ) {
      ...Attachment
    }
  }
  ${AttachmentFragmentDoc}
`
export type UpdateAttachmentMutationFn = Apollo.MutationFunction<
  UpdateAttachmentMutation,
  UpdateAttachmentMutationVariables
>

/**
 * __useUpdateAttachmentMutation__
 *
 * To run a mutation, you first call `useUpdateAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAttachmentMutation, { data, loading, error }] = useUpdateAttachmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAttachmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAttachmentMutation,
    UpdateAttachmentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateAttachmentMutation,
    UpdateAttachmentMutationVariables
  >(UpdateAttachmentDocument, options)
}
export type UpdateAttachmentMutationHookResult = ReturnType<
  typeof useUpdateAttachmentMutation
>
export type UpdateAttachmentMutationResult =
  Apollo.MutationResult<UpdateAttachmentMutation>
export type UpdateAttachmentMutationOptions = Apollo.BaseMutationOptions<
  UpdateAttachmentMutation,
  UpdateAttachmentMutationVariables
>
export const DeleteAttachmentDocument = gql`
  mutation DeleteAttachment($id: ID!) {
    attachment: deleteAttachment(id: $id)
      @rest(
        type: "DeleteResponse"
        bodySerializer: "attachment"
        method: "DELETE"
        endpoint: "delete"
        path: "/project-list/attachments/{args.id}"
      ) {
      success
    }
  }
`
export type DeleteAttachmentMutationFn = Apollo.MutationFunction<
  DeleteAttachmentMutation,
  DeleteAttachmentMutationVariables
>

/**
 * __useDeleteAttachmentMutation__
 *
 * To run a mutation, you first call `useDeleteAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAttachmentMutation, { data, loading, error }] = useDeleteAttachmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAttachmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteAttachmentMutation,
    DeleteAttachmentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteAttachmentMutation,
    DeleteAttachmentMutationVariables
  >(DeleteAttachmentDocument, options)
}
export type DeleteAttachmentMutationHookResult = ReturnType<
  typeof useDeleteAttachmentMutation
>
export type DeleteAttachmentMutationResult =
  Apollo.MutationResult<DeleteAttachmentMutation>
export type DeleteAttachmentMutationOptions = Apollo.BaseMutationOptions<
  DeleteAttachmentMutation,
  DeleteAttachmentMutationVariables
>
